module.exports = __webpack_public_path__ + "assets/img/14-l.436c699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/14-l.jpg
// module id = s3EE
// module chunks = 0